const reducer = (state, { giftCard }) => ({
  ...state,
  giftCardToRemove: giftCard,
  waiting: true,
});

export default reducer;
